/* KAAFEY storefront — photo scroll story, optional 3D model, buy flow */
(() => {
  const STEPS = 6;
  const clamp = (n, lo = 0, hi = 1) => Math.max(lo, Math.min(hi, n));

  function loadModel(stage, journey) {
    const src = stage.dataset.model;
    if (!src || !window.Shopify || typeof Shopify.loadFeatures !== 'function') return null;
    const holder = stage.querySelector('.shot-model');
    const state = { el: null };
    Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: err => {
      if (err) return;
      const mv = document.createElement('model-viewer');
      mv.setAttribute('src', src);
      mv.setAttribute('camera-orbit', '0deg 80deg 105%');
      mv.setAttribute('interaction-prompt', 'none');
      mv.setAttribute('disable-zoom', '');
      mv.setAttribute('shadow-intensity', '1');
      mv.setAttribute('exposure', '1.05');
      mv.setAttribute('alt', holder.getAttribute('aria-label') || 'KAAFEY');
      mv.addEventListener('load', () => journey.classList.add('has-model'));
      holder.appendChild(mv);
      state.el = mv;
    } }]);
    return state;
  }

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const journey = root.querySelector('.journey');
    const stage = root.querySelector('.stage');
    const steps = [...root.querySelectorAll('.step-copy')];
    const navs = [...root.querySelectorAll('[data-goto]')];
    const layers = [...root.querySelectorAll('.shot-layer')];
    const counters = root.querySelectorAll('[data-step-counter]');
    const labels = root.querySelectorAll('[data-step-label]');
    const bar = root.querySelector('.journey-progress i');
    const heatEl = root.querySelector('[data-heat-target]');
    const heatVal = root.querySelector('[data-heat-value]');
    const shop = root.querySelector('#shop');
    const sticky = root.querySelector('.sticky-buy');
    let active = -1, progress = 0, ticking = false, inView = false, model = null;

    function setStep(n) {
      if (n === active) return;
      active = n;
      journey.dataset.step = n;
      steps.forEach((a, i) => { a.classList.toggle('is-active', i === n); a.setAttribute('aria-hidden', i === n ? 'false' : 'true'); });
      navs.forEach((b, i) => { b.classList.toggle('is-active', i === n); if (i === n) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
      layers.forEach(l => l.classList.toggle('is-on', Number(l.dataset.for) === n));
      const num = String(n + 1).padStart(2, '0');
      counters.forEach(c => { c.textContent = num; });
      labels.forEach(l => { l.textContent = navs[n] ? navs[n].dataset.label : ''; });
    }
    function frame() {
      ticking = false;
      if (journey) {
        const r = journey.getBoundingClientRect();
        inView = r.top < innerHeight && r.bottom > 0;
        progress = clamp(-r.top / Math.max(1, journey.offsetHeight - innerHeight));
        const phase = progress * STEPS;
        setStep(Math.min(STEPS - 1, Math.floor(phase)));
        const heat = clamp(phase - 3);
        journey.style.setProperty('--heat', heat.toFixed(3));
        if (heatEl && heatVal) { const t = parseFloat(heatEl.dataset.heatTarget) || 0; heatVal.textContent = Math.round(20 + heat * (t - 20)) + '°'; }
        if (bar) bar.style.transform = 'scaleX(' + progress.toFixed(4) + ')';
        if (model && model.el && inView && !reduced) model.el.cameraOrbit = (-20 + progress * 380).toFixed(1) + 'deg 78deg 105%';
        if (three) { const st = Math.min(STEPS - 1, Math.floor(phase)); three.setProgress(progress, st, clamp(phase - st)); three.setVisible(inView); }
      }
      if (sticky && shop) {
        const s = shop.getBoundingClientRect();
        const show = scrollY > innerHeight * .9 && !(s.top < innerHeight && s.bottom > 0) && !(inView && innerWidth > 760);
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('button').forEach(b => { b.tabIndex = show ? 0 : -1; });
      }
    }
    const schedule = () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });

    navs.forEach(b => b.addEventListener('click', () => {
      const n = Number(b.dataset.goto);
      const top = journey.getBoundingClientRect().top + scrollY;
      scrollTo({ top: top + (journey.offsetHeight - innerHeight) * ((n + .45) / STEPS), behavior: reduced ? 'auto' : 'smooth' });
    }));

    // Load images of the journey early enough, and the 3D scene only when needed.
    // Order of preference: real .glb (when supplied) -> built-in three.js model -> photo story (low-power / no WebGL).
    let three = null;
    const lowPower = (navigator.connection && navigator.connection.saveData) || (navigator.deviceMemory || 8) <= 2 || reduced;
    const start3D = () => {
      if (!stage || !stage.dataset['3d'] || lowPower) return;
      const canvas = stage.querySelector('.shot-3d');
      const probe = document.createElement('canvas');
      if (!canvas || !(probe.getContext('webgl2') || probe.getContext('webgl'))) return;
      import(new URL(stage.dataset['3d'], location.href).href).then(mod => {
        three = mod.createKaafey3D(canvas, { maxDpr: (navigator.hardwareConcurrency || 8) <= 4 ? 1 : 1.6 });
        three.setProgress(progress, Math.max(0, active), 0);
        three.setVisible(inView);
        journey.classList.add('has-3d');
      }).catch(e => { console.warn('KAAFEY 3D unavailable', e); });
    };
    if (journey && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        if (!entries.some(e => e.isIntersecting)) return;
        journey.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
        if (stage && stage.dataset.model) model = loadModel(stage, journey); else start3D();
        io.disconnect();
      }, { rootMargin: '900px 0px' });
      io.observe(journey);
    }

    // Gallery dots (built from the slides that actually rendered)
    const track = root.querySelector('.gallery-track');
    const dotsWrap = root.querySelector('[data-dots]');
    if (track && dotsWrap) {
      const slides = track.querySelectorAll('.gallery-slide');
      if (slides.length > 1) {
        slides.forEach((_, i) => {
          const d = document.createElement('button');
          d.type = 'button'; d.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
          if (i === 0) d.classList.add('is-active');
          d.addEventListener('click', () => track.scrollTo({ left: track.clientWidth * i, behavior: reduced ? 'auto' : 'smooth' }));
          dotsWrap.appendChild(d);
        });
        const dots = [...dotsWrap.children];
        track.addEventListener('scroll', () => { const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); dots.forEach((d, j) => d.classList.toggle('is-active', i === j)); }, { passive: true });
      }
    }

    // Dialog + buy flow
    const dialog = root.querySelector('.coffee-dialog');
    if (dialog) {
      dialog.querySelector('.dialog-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    }
    const status = root.querySelector('.buy-status');
    root.querySelectorAll('[data-buy]').forEach(button => button.addEventListener('click', async () => {
      if (root.dataset.available !== 'true' || !root.dataset.variant) { if (dialog) dialog.showModal(); return; }
      const items = [{ id: Number(root.dataset.variant), quantity: 1 }];
      root.querySelectorAll('[data-addon]:checked').forEach(i => items.push({ id: Number(i.value), quantity: 1 }));
      button.disabled = true;
      if (status) status.textContent = root.querySelector('[data-copy-loading]').textContent;
      try {
        const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!res.ok) throw new Error('cart');
        location.assign(base + (root.dataset.after === 'cart' ? 'cart' : 'checkout'));
      } catch (e) {
        if (status) status.textContent = root.querySelector('[data-copy-error]').textContent;
        button.disabled = false;
      }
    }));

    frame();
  }

  const boot = () => document.querySelectorAll('.coffee-experience').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('.coffee-experience')));

  // Footer localization: submit on change
  document.addEventListener('change', e => { const f = e.target.closest && e.target.closest('form.localization'); if (f) f.submit(); });
})();
